import type { Column } from '@podus/ui';

function escapeCell(value: unknown): string {
    if (value === null || value === undefined) return '';
    const str = String(value);
    if (/[",\n\r]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
}

/**
 * Trigger a browser download of the given rows as CSV. Uses each column's `key`
 * to read the cell value and `label` as the header. Skips the synthetic "actions"
 * column if present.
 */
export function exportCSV<T>(filename: string, columns: Column<T>[], rows: T[]): void {
    const exportable = columns.filter((c) => c.key !== 'actions');
    const header = exportable.map((c) => escapeCell(c.label)).join(',');
    const body = rows
        .map((row) =>
            exportable.map((c) => escapeCell((row as Record<string, unknown>)[c.key])).join(','),
        )
        .join('\n');

    const csv = `${header}\n${body}`;
    const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
